module.exports = ".mgr-20{\r\n    margin-right : 20px;\r\n}\r\n.mgr-10{\r\n    margin-right : 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2124-ydivision2/ydivision2.component.css
// module id = ./src/app/a2124-ydivision2/ydivision2.component.css
// module chunks = main